<template>
  <div class="course_list">
    <p class="hint" v-if="JSON.stringify(list)=='[]'">暂无课时</p>
    <div class="content_box" :class="[list.length<2 ?'special':'' ]">
      <div
        :class="['content', 'content_'+item.web_custom_type,isNoviceClass?'novice_class':'', 'cursor', 'shadow' + subType]"
        v-for="(item,index) in list "
        :key="index"
        @click="go_page(item.web_custom_type,item)"
      >
        <div class="practiceStatus" v-if="practiceStatus[item.practiceStatus] && item.web_custom_type > 1" v-text="practiceStatus[item.practiceStatus]"></div>
        <span
          :class="['icon',(subject==1 || subject==2 || subject==3) &&!isNoviceClass  ? 'icon'+subject : isNoviceClass?'icon1':'icon']"
        >
          <div class="animation_voice" v-if="item.web_custom_type==2 && item.lessonType != 7"></div>
          <img
            ondragstart="return false;"
            v-if="(item.lessonType == 3 || item.lessonType == 6) && subject == 3"
            :src="`/static/img/course/number/yingyu/english.png`"
            alt
          />
          <img
            ondragstart="return false;"
            v-if="item.lessonType == 7"
            :src="`/static/img/course/number/${subType}/homework.png`"
            alt
          />
          <img
            ondragstart="return false;"
            v-show="item.web_custom_type!=2 && (subject == 3 ? (item.lessonType != 3 && item.lessonType != 6) : true) && item.lessonType != 7"
            :src="'/static/img/course/number/'+subType+'/'+item1+'.png'"
            alt
            v-for="(item1,index1) in splitIndex(item.sort)"
            :style="{position: 'absolute',left:item.sort>9 ? (index1 == 0?'-27px' : '20px' ):'0px'}"
            :key="index1"
          />
          <div
            v-if="item.web_custom_type < 2"
            class="lock"
            style="{position: 'absolute'; width: 129px;height: 129px; zIndex: 10;}"
          ></div>
          <!-- <img
            v-if="item.web_custom_type < 2"
            src="/static/img/course/iconbg/lock.png"
          style="{position: 'absolute'; zIndex: 10;}">-->
        </span>
        <!-- <img
          class="headset"
          :src="isNoviceClass?'/static/img/course/novice_headset.png':subject==1 || subject==2 || subject==3 ? '/static/img/course/'+subject+'headset.png':'/static/img/course/mheadset.png'"
          alt
        />-->
        <span
          class="text bold"
          :class="[item.web_custom_type > 1 ? (subject <=4 ? 'text'+subject :''):(subject <= 4 ? 'text'+subject + ' opa' : '')]"
        >{{item.title}}</span>
        <div v-if="item.web_custom_type==2" class="attend_class" :class="['classing'+subType]" v-text="btnTxt(item)"></div>
        <!--时间>2030-01-01 24:59:59 1893517199000 暂未开课开讲-->
        <b
          v-if="item.web_custom_type < 2"
          :class="[item.web_custom_type != 0 ?'classing'+subType : '', subject<=4 ? 'bcoin'+subject :'bcoin4', 'zhengyuantop']"
        >
          {{ handleTime(item.beginTime) >= 1893427200000 ? '暂未开课' : item.me_begin_time_man }}
        </b>
        <div v-if="item.web_custom_type == 3">
          <div class="flx">
            <div class="statuicon"
            v-for="(v,i) in item.lessonListChild.length?showIconFn(item.lessonListChild):[item]" :key="i"
            :class="[lineStatus(v) ? '' : 'opa4', 'statuicon_' + subType]"
            >
              <img
                :src="`../../../../static/img/course/iconbg/${subType}/status/${getLessionType(v)}.png`"
                alt
              />
            </div>
          </div>
        </div>
      </div>
      <icp />
    </div>
    <courseAlert
      :show="alertData.show"
      :btn="alertData.btn"
      :cancal="alertData.cancal"
      :lessonName="alertData.lessonName"
      :imgNum="alertData.imgNum"
      :subType="subType"
      @cancelEvent="cancelEvent"
      @ensure="go_page(2,alertData.data,'alert')"
    ></courseAlert>
    <toast :showText="showText" v-if="showText" @toastCallBack="showText=''"></toast>
    <loadError
      textColor="#fff"
      :errBtnStyle="errBtnStyle"
      style="margin-top:-83px;"
      @loadAgain="getDataAgain"
      v-if="loadErrorShow"
    />
    <alert
      :sameTwo="alertText"
      :btn="'我知道了'"
      :show="isCanPlay"
      @ensure="closeAlert"
    ></alert>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import courseAlert from "./course_alert";
import toast from "../../basic/toast";
import loadError from "../../basic/loadError";
import icp from "@/components/basic/icp.vue";
import alert from "@/components/basic/alert.vue";
import lottie from "lottie-web-limi";
import common from "common";
import utils from 'utils';
export default {
  name: "course_list",
  props: ["subType"],
  data() {
    return {
      alertText: '出错了，请稍后重试~',
      isCanPlay: false,
      list: "",
      alertData: {},
      num: 0,
      interval: null,
      showText: "",
      practiceStatus:{
         // 10:'未完成',
         // 11:'待订正',
      },
      loadErrorShow: false,
      AnimList: [],
      errColor: {
        yuwen: "#EC7126",
        shuxue: "#0B7FC7",
        yingyu: "#5746EB",
        beiyong: "#DB4729",
      },
    };
  },
  components: {
    courseAlert,
    toast,
    loadError,
    icp,
    alert
  },
  computed: {
    ...mapState([
      "class_id",
      "subject",
      "round_robin_interval",
      "lesson_id",
      "liveVideoUrlData",
      "lessonCoin",
      "lessonState",
      "isNoviceClass",
      "showCompose",
      "composeLessInfo",
      "grade",
      "class_type",
      "isGhost",
      "oldUser",
      "class_status"
    ]),
    ...mapGetters(["isExperientialCourse"]),
    errBtnStyle() {
      return {
        color: this.errColor[this.subType] || "#ccc",
        background: "#fff",
      };
    },
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions(["getLessonList", "getLessonsState", "getZip","getExperienceLessonList","isPlayTime"]),
    ...mapMutations([
      "savePlaybackData",
      "saveBaseLessonInfo",
      "updataVideoUrlState",
      "refreshNet",
      "saveLessonInfo",
      "upDateLessonState",
      "saveComposeLessInfo",
    ]),
    handleTime(time) {
      return new Date(time).getTime();
    },
    //关闭按钮
    closeAlert() {
      this.isCanPlay = false;
    },
    getLessionType(i) {
      let type = "";
      let item = i;
      switch (true) {
        case item.lessonType == 1:
          type = item.isPlay == 1 ? "live" : "live_off";
          break;
        case item.lessonType == 6:
          type = item.isPlay == 1 ? "prev" : "prev_off";
          break;
        case item.lessonType == 3:
          type = item.isPlay == 1 ? "exer" : "exer_off";
          break;
        case item.lessonType == 7:
          // type = this.compareTimeSize(item.beginTime) ? "homework" : "homework_off";
          type = 'homework_off';
          break;
        // case item.state < 2:
        //   type = "lock";
        //   break;
        default:
          type = item.isPlay == 1 ? "live" : "live_off";
          break;
      }
      return type;
    },
    lineStatus(v){
      if(v.lessonType==7){
        return this.compareTimeSize(v.beginTime)
      }else if(v.isPlay == 1){
        return true;
      }
    },
    compareTimeSize(time){
      let beginTime = (new Date(time.replace(/-/g, "/")).getTime())/1000;
      return common.getTemServerTime()>beginTime || this.isGhost;
    },
    init() {
      this.getData();
    },
    getDataAgain() {
      this.getData();
    },
    btnTxt(item){
      if(item.lessonType == 7){
        if(item.practiceStatus==11){
           return "去订正"
        }
        return "去交作业"
      }
      return "开始学习"
    },
    showIconFn(list){//存在多个相同小图标只展示一个
      const listData = JSON.parse(JSON.stringify(list))
      let arr = [];
      let lessonTypeArr = [];
      let statusData = {
        isplay:{},
        state:{},
      }
      listData.forEach((v)=>{
        if(!statusData.isplay[v.lessonType]){
          statusData.isplay[v.lessonType] = [];
        }
        if(!statusData.state[v.lessonType]){
          statusData.state[v.lessonType] = [];
        }
        statusData.state[v.lessonType].push(v.state);
        statusData.isplay[v.lessonType].push(v.isPlay);
        if(!lessonTypeArr.includes(v.lessonType)){
          arr.push(v)
          lessonTypeArr.push(v.lessonType)
        }
      })
      arr.forEach((v)=>{
        v.isPlay = 0;
        v.state = 0;
        const isplay = statusData.isplay[v.lessonType];
        const state = statusData.isplay[v.lessonType];
        if(!isplay.includes(0)){
          v.isPlay = 1;
        }
        if(state.includes(2) || state.includes(3)){
          v.state = 2;
        }
      })
      // console.log(arr)
      return arr;
    },
    // judgePDF(res) {
    //   let {zipUrl, pdfList} = res.learningMaterialsList;
    //   let show = false;
    //   if (zipUrl && pdfList.length > 0) show = true;
    //   this.$emit('showpdfbtn', show);
    // },
    formatData(res) {
      common.setSession("lesson_list_data", res);
      this.saveBaseLessonInfo(res);
      // this.judgePDF(res)
      // 初始化进度条
      if(LIMI_ENV === "electron") {
        utils.getNodeStorge("progressBar") == null && utils.setNodeStorge('progressBar', res.progressBar);
      }else {
        common.get('progressBar') == null && common.set('progressBar', res.progressBar);
      }
      this.alertData = {};
      res.lessonList.forEach((v, i) => {
        let type = 0; //0未上课 1等待上课 2正在上课 3上完课
        const isNextLesson = v.lessonListChild.some((i)=>{
          if(i.lessonType==7 && this.compareTimeSize(i.beginTime) && v.practiceStatus==0){
            v.practiceStatus=10;
          }
          return i.isNextLesson == 1
        })
        if(v.lessonType==7 && v.practiceStatus==0){
          v.practiceStatus=10
        }
        if (v.isNextLesson == 0 && isNextLesson) {
          v.isNextLesson = 1;
        }
        if (v.isNextLesson == 1) {
          if (v.state == 2) {
            if (v.lessonListChild.length) {
              let index = v.lessonListChild.findIndex((item) => {
                return item.state == 2;
              });
              v.videoUrl = v.lessonListChild[index].videoUrl;
            }
            type = 2;
            if (this.$route.query["from"] !== "video") {
              if (this.subject == 3) {
                this.alertData = {
                  show: true,
                  btn: "进入",
                  cancal: "取消",
                  lessonName: v.title,
                  imgNum: v.sort,
                  data: v,
                };
              } else {
                this.alertData = {
                  show: true,
                  btn: "进入",
                  cancal: "取消",
                  lessonName: v.title,
                  imgNum: i + 1,
                  data: v,
                };
              }
              this.$root.eventHub.$emit("createLog", {
                id: "LMTrackEventLivingNotice",
              });
            }
          } else {
            if (!!v.beginTime) {
              let metime = v.beginTime.split(" ")[0];
              if (metime) {
                let arr = metime.split("-");
                if(v.lessonType==1 || v.lessonType==5){
                  metime =`${arr[1]}月${arr[2]}日`
                }else{
                  metime =`${arr[1]}月${arr[2]}日`
                }
              } else {
                metime = "等待开课";
              }
              v.me_begin_time_man = metime;
            }
            type = v.state == 3 ? 3 : 1;
            // let flag = v.lessonListChild.some((i) => {
            //   if(i.lessonType==7 && this.compareTimeSize(i.beginTime)){
            //     i.state=3
            //   }
            //   return i.state == 3
            // })
            // if (type < 2 && flag) {
            //   type = 3;
            // };
          }
          if(LIMI_ENV === "electron" && this.$route.query.from !== "video"){
            this.getZip({ course_id: v.courseId });
          }
        } else {
          type = v.state == 1 ? 0 : v.state;
          // let flag = v.lessonListChild.some((i) => {
          //   if(i.lessonType==7 && this.compareTimeSize(i.beginTime)){
          //     i.state=3;
          //   }
          //   return i.state == 3
          // })
          // if (type < 2 && flag) {
          //   type = 3;
          // }
          let metime = v.beginTime.split(" ")[0];
          if(metime){
            let arr = metime.split("-");
            if(v.lessonType==1 || v.lessonType==5){
              metime =`${arr[1]}月${arr[2]}日`
            }else{
              metime =`${arr[1]}月${arr[2]}日`
            }
            v.me_begin_time_man = metime;
          }
        }
        v.week === 1 && v.state == 3 ? type = 2 : '';
        if(v.lessonType==7 && this.compareTimeSize(v.beginTime)){
          if(v.practiceStatus==12){
            type=3
          }else{
            type=2
          }
        }
        v.web_custom_type = type;
        if (LIMI_ENV === "electron" && this.isExperientialCourse && this.$route.query.from !== "video") {
          this.getZip({ course_id: v.courseId });
        }
      });
      //保存长连接地址
      if (res.wssUrl) {
        common.setSession("websocket_wss_url", res.wssUrl);
      } else {
        common.setSession("websocket_wss_url", "");
      }
      if(res.artemisGoldMedalInfo && res.artemisGoldMedalInfo.isShowEntrance == 1){
        this.$parent.dailyTasksShow = true;
      }
      this.list = res.lessonList;
      let index = this.list.findIndex((item) => {
        return item.lessonId == this.composeLessInfo.lessonId;
      });
      if (index != -1 && this.showCompose) {
        this.$nextTick(() => {
          this.saveComposeLessInfo(
            Object.assign(this.list[index], { showCompose: false })
          );
          this.$nextTick(() => {
            this.saveComposeLessInfo(
              Object.assign(this.list[index], { showCompose: true })
            );
          });
        });
      }
      setTimeout(() => {
        this.scrollTop();
        this.$nextTick(this.playAmn);
      }, 0);
    },
    getData() {
      //获取课时列表数据
      this.list = "";
      this.loadErrorShow = false;
      const methodName = this.class_type==2 ? 'getExperienceLessonList' : 'getLessonList';
      const params = {
        classId: this.class_id,
        status: this.class_status,
        client: common.client,
        version: common.version,
      };
      if(this.class_type!=2) {
        params.oldUser = this.oldUser;
      }
      this[methodName](params)
        .then(
          ({ res, ok }) => {
            if (!ok) {
              this.list = "";
              this.loadErrorShow = true;
              return;
            }
            if (JSON.stringify(res) === "[]") {
              this.list = [];
              return;
            }
            this.formatData(res);
          },
          () => {
            this.loadErrorShow = true;
            this.list = "";
          }
        )
        .catch(() => {
          this.loadErrorShow = true;
          this.list = "";
        });
    },
    getState() {
      if(!this.class_id)return;
      this.getLessonsState({
        classIds: [this.class_id],
        roundRobinInterval: this.round_robin_interval,
      }).then(({ res, ok }) => {
        if (!ok || !res || !res.length) return;
        this.DestructAmn();
        this.getData();
      });
    },
    splitIndex(index) {
      //课时点索引截取为数组
      var index = new String(index);
      if (index.length == 1) {
        return [index];
      } else {
        return index.split("");
      }
    },
    splitIndexEnglish(index) {
      if (index != 0) {
        var index = new String(index);
        if (index.length == 1) {
          return [index];
        } else {
          return index.split("");
        }
      } else {
        return [index];
      }
    },
    scrollTop() {
      //滚动到正在上课的课时点的位置
      var dom = document.getElementsByClassName("course_list")[0];
      var dom1 = document.getElementsByClassName("content_2")[0];
      dom1 = dom1 || document.getElementsByClassName("content_1")[0];
      var length = dom1 ? dom1.offsetTop : 0;
      if (dom) {
        dom.scrollTop = length;
      }
    },
    async go_page(type, data, source) {
      if (!navigator.onLine) {
        this.refreshNet(false);
        return;
      }
      // 检测是否在可播放的时间段内
      this.isPlayTime()
        .then(({res, ok})=> {
          if(!ok) return;
          this.isCanPlay = !res.look;
          if(this.isCanPlay) {
            this.alertText = res.desc
          }else {
            this.dealGoPage(type, data, source)
          }
        })
    },
    dealGoPage(type, data, source) {
      let index = this.list.findIndex((item) => {
        return item.lessonId == data.lessonId;
      });
      this.$root.eventHub.$emit("createLog", {
        id: "LMTrackEventLessonCardClicked",
        data: {
          lesson_id: data.lessonId,
          index: 1 + index,
          count: this.list.length,
        },
      });
      if (type == 0 || type == 1) {
        this.showText = '课程暂未解锁';
        return;
      }
      if (data.lessonListChild.length > 1 && !source) {
        this.saveComposeLessInfo(Object.assign(data, { showCompose: true }));
        return;
      }
      if (
        data.lessonListChild.length > 0 &&
        data.lessonListChild.some((v) => v.state == 2)
      ) {
        let index = data.lessonListChild.findIndex((v) => v.state == 2);
        data = data.lessonListChild[index];
      }
      this.saveLessonInfo(data);
      if(data.lessonType == 7){
        this.$router.push("/homework");
        common.setSession('homeWorkTitle',data.title);
        LIMI_ENV === "electron" && this.getZip({ course_id: data.courseId });
      }else if (type == 2 || [121,122,123,124,126].includes(data.lessonType) || type == 3) {
        if (source) {
          this.$root.eventHub.$emit("createLog", {
            id: "LMTrackEventLivingin",
          });
        }
        //正在上课
        if (this.lesson_id != this.liveVideoUrlData.lesson_id) {
          this.updataVideoUrlState({
            lesson_id: data.lessonId,
            live_video_url_stream: "",
            live_video_url_type: "",
            live_video_url: "",
          });
        }
        let playbackData = {
          lesson_type: data.lessonType,
          play_back_url: data.playbackUrl,
          playback_url_tag: data.playbackUrlTagList,
          time_length: data.timeLength,
          title: data.title,
          begin_time: data.beginTime,
        };
        this.savePlaybackData(playbackData);
        this.$router.push({
          name: "video",
          params: {
            name: "first",
          },
        });
      }
      // else if (type == 3) {
      //   //视频回放
      //   if (!data.playbackUrl) {
      //     this.showText = "课程准备中，请稍候"
      //     return;
      //   }
      //   let playbackData = {
      //     lesson_type: data.lessonType,
      //     play_back_url: data.playbackUrl,
      //     playback_url_tag: data.playbackUrlTagList,
      //     time_length: data.timeLength,
      //     title: data.title,
      //     begin_time: data.beginTime,
      //   };
      //   this.savePlaybackData(playbackData);
      //   this.$router.push("playback");
      //   LIMI_ENV === "electron" && this.getZip({ course_id: data.courseId });
      // }
    },
    cancelEvent() {
      this.alertData.show = false;
    },
    DestructAmn() {
      this.AnimList.forEach((v) => {
        if (!!this[v].destroy) {
          try {
            this[v].destroy();
          } catch (e) {
            console.log(e);
          }
          this[v] = false;
        }
      });
    },
    playAmn() {
      let doms = document.getElementsByClassName("animation_voice");
      let that = this;
      this.AnimList = [];
      Array.prototype.forEach.call(doms, (v, i) => {
        if (!that["anim" + i]) {
          that.AnimList.push("anim" + i);
          that["anim" + i] = lottie.loadAnimation({
            container: v, // the dom element that will contain the animation
            renderer: "svg", //svg,canvas
            loop: true,
            autoplay: true,
            path: "/static/lottie/classing.json",
          });
        }
      });
      if (!this.alentanim) {
        that.AnimList.push("alentanim");
        this.alentanim = lottie.loadAnimation({
          container: document.querySelector(".animation_lottie"), // the dom element that will contain the animation
          renderer: "svg", //svg,canvas
          loop: true,
          autoplay: true,
          path: "/static/lottie/classing.json",
        });
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>
<style scoped lang="less" rel="stylesheet/less">
::-webkit-scrollbar {
  width: 0px;
}

.animation_voice {
  width: 129px;
  height: 129px;
  position: absolute;
  left: 0px;
  top: 0px;
  font-size: 0;
}
.course_list {
  width: 100%;
  overflow-y: scroll;
  margin-top: 83px;
  height: 100%;
  position: relative;
  padding-bottom: 120px;
  .content_box {
    width: 840px;
    position: relative;
    margin: 0 auto;
    min-height: 100%;
    display: flex;
    flex-wrap: wrap;
    padding-top: 67px;
    justify-content: flex-start;
    .content {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 235px;
      height: 287px;
      background: #fff7ed;
      border-radius: 46px 46px 121px 121px;
      box-shadow: 0px 6px 0px 0px #ffe3c2;
      margin-bottom: 55px;
      .icon {
        position: relative;
        margin-top: 23px;
        display: inline-block;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 10;
        width: 129px;
        height: 129px;
        line-height: 129px;
        text-align: center;
        background: #275db3;
        img {
          height: 129px;
        }
        .lock {
          width: 129px;
          height: 129px;
          position: absolute;
          z-index: 10;
          background: url("/static/img/course/iconbg/lock.png");
          background-size: cover;
        }
      }
      .attend_class {
        padding-top: 1px;
        width: 145px;
        height: 35px;
        border-radius: 18px;
        font-size: 16px;
        font-family: HYZhengYuan;
        font-weight: 600;
        text-align: center;
        color: #ffffff;
        line-height: 35px;
      }
      .zhengyuantop {
        padding-top: 2px;
      }
      .icon1 {
        background: #00757b;
        background-size: cover;
      }
      .icon3 {
        background: #6336b4;
        background-size: cover;
      }
      .headset {
        position: absolute;
        top: 50px;
        width: 215px;
        left: -31px;
        z-index: 1;
        display: none;
      }
      .flx {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .statuicon {
        &::before{
          content: "";
          display: inline-block;
          width: 7px;
          height: 2px;
          background: #2d9cdf;
          border-radius: 2px;
          margin: 2px;
        }
        &:first-child::before{
          display: none;
        }
        img {
          width: 32px;
          height: 32px;
        }
      }
      .statuicon_yuwen::before {
        background: #ff7b2b;
      }
      .statuicon_shuxue::before {
        background: #2d9cdf;
      }
      .statuicon_yingyu::before {
        background: #7b69ef;
      }
      .statuicon_beiyong::before {
        background: #ea674d;
      }
      .opa4::before {
        opacity: 0.4;
      }
      b {
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: HYZhengYuan;
        min-width: 130px;
        padding: 0 11px;
        height: 35px;
        line-height: 35px;
        font-size: 16px;
        border-radius: 20px;
        // transform: translateX(-50%);
        color: #275db3;
        letter-spacing: 0;
        text-align: center;
        background-color: #bed1ee;
        background-size: 24px 24px;
        z-index: 11;
        img {
          width: 24px;
          height: 24px;
          line-height: 35px;
          margin-right: 7px;
        }
      }
      .bcoin1 {
        color: #fff;
        background-color: #acd6f0;
      }
      .bcoin2 {
        color: #fff;
        background-color: #ffd9ab;
      }
      .bcoin3 {
        color: #fff;
        background-color: #c5b9db;
      }
      .bcoin4 {
        color: #fff;
        background-color: #ffbdb0;
      }
      .classingyuwen {
        background: #ed7227;
      }
      .classingshuxue {
        background: #0086d9;
      }
      .classingyingyu {
        background: #6850fc;
      }
      .classingxinshou {
        background: #009d76;
      }
      .classingbeiyong {
        background: #db4729;
      }
      .text,
      .text1,
      .text2,
      .text3 {
        // position: absolute;
        margin: 12px 0 10px;
        width: 200px;
        height: 48px;
        // top: 192px;
        // left: -31px;
        z-index: 10;
        color: #d06829;
        font-size: 20px;
        text-align: center;
        font-family: HYZhengYuan;
        font-weight: 600;
        line-height: 24px;
        word-break: break-word;
        overflow : hidden;/*必须结合的属性,当内容溢出元素框时发生的事情*/
        text-overflow: ellipsis;/*可以用来多行文本的情况下，用省略号“…”隐藏超出范围的文本 。*/
        display: -webkit-box;/*必须结合的属性 ，将对象作为弹性伸缩盒子模型显示 。*/
        -webkit-line-clamp: 2;/*用来限制在一个块元素显示的文本的行数。*/
        /*! autoprefixer: off */
        -moz-box-orient: vertical;
        -webkit-box-orient: vertical;
        /*! autoprefixer: on */
      }
      .text1 {
        color: #0b7fc7;
      }
      .text2 {
        color: #d06829;
      }
      .text3 {
        color: #5654b3;
      }
      .text4 {
        color: #db4729;
      }
      .opa {
        opacity: 0.6;
      }
    }
    .shadowshuxue {
      background: #f2faff;
      box-shadow: 0px 4px 0px 0px #a5ddff;
    }
    .shadowyuwen {
      box-shadow: 0px 6px 0px 0px #ffe3c2;
    }
    .shadowyingyu {
      background: #f5edff;
      box-shadow: 0px 4px 0px 0px #dbcaff;
    }
    .shadowxinshou {
      background: #f5fff9;
      box-shadow: 0px 4px 0px 0px #b3f7d0;
    }
    .shadowbeiyong {
      background: #fff3f1;
      box-shadow: 0px 4px 0px 0px #ffcec3;
    }
    .content:nth-child(3n + 2) {
      margin: 0 66px;
    }
  }
  .content:nth-child(6n + 1) {
    .icon {
      background: url(../../../../static/img/course/iconbg/beiyong/1.png)
        no-repeat;
      background-size: cover;
    }
    .icon2 {
      background: url(../../../../static/img/course/iconbg/yuwen/1.png)
        no-repeat;
      background-size: cover;
    }
    .icon1 {
      background: url(../../../../static/img/course/iconbg/shuxue/1.png)
        no-repeat;
      background-size: cover;
    }
    .icon3 {
      background: url(../../../../static/img/course/iconbg/yingyu/1.png)
        no-repeat;
      background-size: cover;
    }
  }
  .content:nth-child(6n + 2) {
    .icon {
      background: url(../../../../static/img/course/iconbg/beiyong/2.png)
        no-repeat;
      background-size: cover;
    }
    .icon2 {
      background: url(../../../../static/img/course/iconbg/yuwen/2.png)
        no-repeat;
      background-size: cover;
    }
    .icon1 {
      background: url(../../../../static/img/course/iconbg/shuxue/2.png)
        no-repeat;
      background-size: cover;
    }
    .icon3 {
      background: url(../../../../static/img/course/iconbg/yingyu/2.png)
        no-repeat;
      background-size: cover;
    }
  }
  .content:nth-child(6n + 3) {
    .icon {
      background: url(../../../../static/img/course/iconbg/beiyong/3.png)
        no-repeat;
      background-size: cover;
    }
    .icon1 {
      background: url(../../../../static/img/course/iconbg/shuxue/3.png)
        no-repeat;
      background-size: cover;
    }
    .icon2 {
      background: url(../../../../static/img/course/iconbg/yuwen/3.png)
        no-repeat;
      background-size: cover;
    }
    .icon3 {
      background: url(../../../../static/img/course/iconbg/yingyu/3.png)
        no-repeat;
      background-size: cover;
    }
  }
  .content:nth-child(6n + 4) {
    .icon {
      background: url(../../../../static/img/course/iconbg/beiyong/4.png)
        no-repeat;
      background-size: cover;
    }
    .icon1 {
      background: url(../../../../static/img/course/iconbg/shuxue/4.png)
        no-repeat;
      background-size: cover;
    }
    .icon2 {
      background: url(../../../../static/img/course/iconbg/yuwen/4.png)
        no-repeat;
      background-size: cover;
    }
    .icon3 {
      background: url(../../../../static/img/course/iconbg/yingyu/4.png)
        no-repeat;
      background-size: cover;
    }
  }
  .content:nth-child(6n + 5) {
    .icon {
      background: url(../../../../static/img/course/iconbg/beiyong/5.png)
        no-repeat;
      background-size: cover;
    }
    .icon1 {
      background: url(../../../../static/img/course/iconbg/shuxue/5.png)
        no-repeat;
      background-size: cover;
    }
    .icon2 {
      background: url(../../../../static/img/course/iconbg/yuwen/5.png)
        no-repeat;
      background-size: cover;
    }
    .icon3 {
      background: url(../../../../static/img/course/iconbg/yingyu/5.png)
        no-repeat;
      background-size: cover;
    }
  }
  .content:nth-child(6n + 6) {
    .icon {
      background: url(../../../../static/img/course/iconbg/beiyong/6.png)
        no-repeat;
      background-size: cover;
    }
    .icon1 {
      background: url(../../../../static/img/course/iconbg/shuxue/6.png)
        no-repeat;
      background-size: cover;
    }
    .icon2 {
      background: url(../../../../static/img/course/iconbg/yuwen/6.png)
        no-repeat;
      background-size: cover;
    }
    .icon3 {
      background: url(../../../../static/img/course/iconbg/yingyu/6.png)
        no-repeat;
      background-size: cover;
    }
  }
  .special {
    justify-content: space-around;
    .content:nth-child(3n + 2) {
      margin: 0;
    }
  }
  .content_box .content_0 {
    /*未开课*/
    .text1 {
      color: #79afd9;
    }
    .text2 {
      color: #d06829;
    }
    .text4 {
      color: #db4729;
    }
  }
  .content_box .content_1 {
    /*即将开课*/
    b {
      background-image: none;
      min-width: 140px;
      padding: 0 5px;
      text-align: center;
      color: #fff;
      background-color: #275db3;
    }
    .bdata1 {
      background-color: #00757b;
    }
    .bdata2 {
      background-color: #b66111;
    }
    .bdata3 {
      background-color: #6336b4;
    }
  }
  .content_box .content_2 {
    /*正在上课*/
    b {
      display: none;
    }
    .headset {
      display: block;
    }
    .bold {
      font-weight: bold;
    }
  }
  .content_box .novice_class {
    /*正在上课*/
    .icon1 {
      background: url(../../../../static/img/course/iconbg/xinshou/1.png)
        no-repeat;
      background-size: cover;
    }
    .text {
      color: #008565;
    }
  }
}
.practiceStatus{
  position: absolute;
  right: -5px;
  top:-2px;
  width: 68px;
  height: 35px;
  background: #e13131;
  border-radius: 13px 20px 20px 0px;
  font-weight: 600;
  color: #fff;
  font-size: 16px;
  line-height: 35px;
}
@media screen and (min-width: 1921px) {
  .content_box {
    width: 841px !important;
    // .content:nth-child(3n + 2) {
    //   margin: 0 183px !important;
    // }
  }
}
.hint {
  width: 200px;
  text-align: center;
  position: absolute;
  font-size: 32px;
  color: #fff;
  top: 50%;
  left: 50%;
  margin-top: -60px;
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/course/course_list.vue